/**
 * Gets 3P products that support a given filter, using ThirdPartyConfigs.
 *
 * This is intentionally in a separate file from filters/index.ts to avoid
 * pulling ThirdPartyConfigs (and its 66 icon-laden config files) into the
 * generateSearchInputs bundle. This file is only imported by UI filter
 * components, not by the generateSearchInputs call path.
 */
import { ThirdPartyConfigs } from '../../constants/3p-product-configs';
import type { FilterId } from '../../constants/filters';
import type { ProductKeys3P } from '../../constants/product-keys';

export const getProducts3PFromConfigForFilter = (filterId: FilterId): ProductKeys3P[] => {
	const productsForFilter: ProductKeys3P[] = [];
	ThirdPartyConfigs.forEach((config, productKey3P) => {
		if (config.filters?.includes(filterId)) {
			productsForFilter.push(productKey3P);
		}
	});
	return productsForFilter;
};
